import Axios from "axios";
import { API_ADMIN } from "../../utils/constants/Api";
import { ActivitySchemaModel } from "../models/ActivitySchemaModel";
import { ProcessStarterActivityModel } from "../models/ProcessStarterActivityModel";

interface ActivityInfo {
	[key: string]: any;
}

export default {
	getStarterActivityList():Promise<ProcessStarterActivityModel[]> {
		return Axios.get(`${API_ADMIN}processes/starter_activities`)
			.then(({data}) => {
				return (data || []).map((p:ProcessStarterActivityModel) => new ProcessStarterActivityModel(p))
			})
	},
	getActivitySchema(idActivity:number):Promise<ActivitySchemaModel> {
		return Axios.get(`${API_ADMIN}processes/activities/${idActivity}/schema`)
			.then(({data}) => {
				return new ActivitySchemaModel(data)
			})
	},	
	validateActivityInstance(idActivity: number, info: ActivityInfo):Promise<any> {
		return Axios.post(`${API_ADMIN}processes/instances/${idActivity}/validate`, info)
			.then(({data}) => {
				return data;
			});
	},
	createInstance(idActivity: number, info: ActivityInfo):Promise<any> {
		return Axios.post(`${API_ADMIN}processes/instances/${idActivity}/create`, info)
			.then(({data}) => {
				return data;
			});
	},
	executeProcessInstance(idActivity: number, info: ActivityInfo):Promise<any> {
		return Axios.post(`${API_ADMIN}processes/instances/${idActivity}/execute`, info)
			.then(({data}) => {
				return data;
			});
	},
	retryLastError(idActivity: number, info: ActivityInfo):Promise<any> {
		return Axios.post(`${API_ADMIN}processes/instances/${idActivity}/retry`, info)
			.then(({data}) => {
				return data;
			});
	},
}
